/* eslint-disable no-nested-ternary */
// TODO:抽空处理这个文件的eslint报错信息主要报错（嵌套的三元表达式代码行数113行-147行），2024-05-15--ypwang
import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, TabPanel, Tabs, Bubble, notification } from 'tea-component';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { ChartCalculateMode } from '@dbl/core/chartEditor';
import AddSource from './addSource';
import PersonalDataSource from './PersonalDataSource';
import { ITableJoinRelation } from './interface';
import { getJoinRelationClazz } from '@/pages/datalab/pages/Multidimensional/utils';
import {getLocalText, useDblIntl} from "@/pages/datalab/utils/utils";
import SqlAddSource from './SqlAddSource';

import './dataSourceRelation.scss';
// import { useTokenFailureSetSessionCache } from '../..';
import { useSelector, shallowEqual } from 'umi';
import { pick } from 'lodash-es';
import SqlViewList from "@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/SqlViewList";
import {dropPageBtnPoints} from "@/pages/datalab/utils/buiredDatalabBtnPoints/dropPageBtnPoint";
import DetailModal from "@/pages/datalab/pages/Multidimensional/Analysis/components/DetailModal";
import useDragDropPageDetail
  from "@/pages/datalab/pages/Multidimensional/Analysis/components/DetailModal/useDragDropPageDetail";
import { resetDimensionPercentageOnDataSourceSwitch } from '@/pages/datalab/pages/Multidimensional/Analysis/components/ChartSettingsV2/utils/resetDimensionPercentageOnDataSourceSwitch';

export default function DataSourceRelation(props: any) {
  const {
    gameCode,
    namespace,
    dataTables,
    dataTableJoinRelations,
    autoSelectTable,
    showSelfJoin,
    isOpenSelfJoin,
    isHaveChart,
    isDragDrop = false,
    chartType = 'Table',
  }: {
    gameCode: string;
    namespace: string;
    dataTables: IGetTableInfoDto[];
    dataTableJoinRelations: ITableJoinRelation[];
    autoSelectTable: boolean;
    showSelfJoin: boolean;
    isOpenSelfJoin: boolean;
    isHaveChart?: boolean;
    isDragDrop?: boolean;
    chartType: string;
  } = props;
  const {
    saveColumnInfos,
    // mode: modes,
    columnRawColumns,
    chartDataSourceEditDisabled,
    sqlViewUpdateDisabled,
  } = useSelector((state: any) => {
    const {
      save_column_infos: saveColumnInfos,
      // mode,
      columnRawColumns,
      chartDataSourceEditDisabled,
      sqlViewUpdateDisabled,
    } = state[namespace];
    return {
      saveColumnInfos,
      // mode,
      columnRawColumns,
      chartDataSourceEditDisabled,
      sqlViewUpdateDisabled,
    };
  });
  const { dblFormatMessage,formatMessage, commonFormatMessage, locale, createDblFormatMessage,isEn } = useDblIntl("multi");
  
  // 先写死simple，后面需要根据编辑的传参展示
  const [activeTab, setActiveTab] = useState('simple');
  const [visible, setVisible] = useState(false);
  const [isFromEdit, setFromEdit] = useState(false); // 对于 SQL View 是编辑, 还是新增
  
  
  // 是否已经有勾选的 数据表作为数据源了.
  const isHaveTables = dataTables && dataTables.length >= 1;
  const [dataSourceOperation, setDataSourceOperation] = useState<string>(isHaveTables ? 'edit' : 'add');
  
  // 添加
  const [tabs, setTabs] = useState([
    {
      id: 'simple',
      label: formatMessage({id: 'dbl_sql_table'}),
    },
    {
      id: 'sqlViewList',
      label: formatMessage({id: 'dbl_sql_view_title'}),
    },
    {
      id: 'sql',
      label: formatMessage({id: 'dbl_sql_view_add_sql'}),
    },
    {
      id: 'personal',
      label: formatMessage({id: 'dbl_personal_data_title'}),
    },
  ]);
  

  const tabsOnActive = (tabs: string) => {
    setActiveTab(tabs?.id || 'simple');
    setFromEdit(false);
  };

  const simpleClass = activeTab === 'simple' ? 'dbl-add-source-simple' : '';

  useEffect(() => {
    if (autoSelectTable && dataTables.length > 0) {
      // selectTables();
      setVisible(true);
      props.dispatch({
        type: `${namespace}/save`,
        payload: {
          autoSelectTable: false,
        },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSelectTable, JSON.stringify(dataTables), JSON.stringify(dataTableJoinRelations)]);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const DragDataTables = useMemo(()=>dataTables?.filter(item=>item?.kind !== 'virtual'),[dataTables]);
  const currentGame = useSelector((state: any) => state?.datalab?.currentGame, shallowEqual);
  const handleBtnBuriedPoint = (tables: any) => {
    if (dataSourceOperation === 'replace') {
      // 点击 Replace按钮 显示的弹窗
      dropPageBtnPoints({
        extInfo: {tables},
        buttonId: '001',
        buttonName: 'Replace',
        uid: gameCode,
        gameName: currentGame?.game_name,
      });
    }
  };
  
  const {openModal: openDetailModal, onClose, ...detailProps} = useDragDropPageDetail({
    isSingle: true,
  });
  
  return (
    <>
      <div className="db-datalab-guide-left-container">
        <div className="left-title">
          <span className="left-title-text">{dblFormatMessage('data_source_status')}</span>
          <Bubble
            dark
            content={(props?.pageConfig?.numberPackage?.disabled) ? dblFormatMessage("data_source_disabled") : undefined}
            placement={'top'}
          >
            <div>
              <Button
                className="left-title-btn left-title-btn-replace"
                style={{
                  display: dataTables && dataTables.length !== 0 ? '' : 'none',
                }}
                type={'link'}
                onClick={() => {
                  setActiveTab(dataTables?.[0]?.kind === 'virtual' ? 'sqlViewList' : (dataTables?.[0]?.kind === 'file' ? 'personal' : 'simple'));
                  setVisible(true);
                  setDataSourceOperation('replace');
                  setTabs([
                    {
                      id: 'simple',
                      label: formatMessage({id: 'dbl_sql_table'}),
                    },
                    {
                      id: 'sqlViewList',
                      label: formatMessage({id: 'dbl_sql_view_title'}),
                    },
                    {
                      id: 'personal',
                      label: formatMessage({id: 'dbl_personal_data_title'}),
                    },
                  ]);
                }}
                disabled={props?.pageConfig?.numberPackage?.disabled || chartDataSourceEditDisabled}
              >
                {dblFormatMessage('replace')}
              </Button>
              <Button
                type={'link'}
                className="left-title-btn"
                style={{
                  display: dataTables && dataTables.length !== 0 ? '' : 'none',
                }}
                onClick={() => {
                  setActiveTab(dataTables?.[0]?.kind === 'virtual' ? 'sql' : (dataTables?.[0]?.kind === 'file' ? 'personal' : 'simple'));
                  setFromEdit(true);
                  setVisible(true);
                  setDataSourceOperation('edit');
                  setTabs([
                    {
                      id: 'simple',
                      label: formatMessage({id: 'dbl_sql_table'}),
                    },
                    {
                      id: 'sqlViewList',
                      label: formatMessage({id: 'dbl_sql_view_title'}),
                    },
                    {
                      id: 'sql',
                      label: formatMessage({id: dataTables?.[0]?.kind === 'virtual' ? 'dbl_sql_view_edit_sql' : 'dbl_sql_view_add_sql'}),
                    },
                    {
                      id: 'personal',
                      label: formatMessage({id: 'dbl_personal_data_title'}),
                    },
                  
                  ]);
                }}
                disabled={props?.pageConfig?.numberPackage?.disabled || chartDataSourceEditDisabled}
              >
                {dblFormatMessage('edit')}
              </Button>
            </div>

          
          </Bubble>
        </div>
        <div
          className="left-btn"
        >
          {isHaveTables ? (
            dataTables && dataTables.length > 1 && dataTableJoinRelations && dataTableJoinRelations.length > 1 ? (
              <div className="table-join">
                {(dataTableJoinRelations || []).map((relation: ITableJoinRelation, index: number) => {
                  const [joinArrow, joinIcon] = getJoinRelationClazz(relation.connect_type);
                  // React.Fragment如果赋值了key会造成前一次的自关联表连接后, 修改表关系后, 左侧数据源的t0无法消除
                  return (
                    <React.Fragment key={relation.table_id}>
                      {/* 关系箭头  右链接：right-otherJoin  左链接：left-otherJoin  全连接：all-otherJoin   内链接：init-otherJoin*/}
                      {/* 关系icon  右链接：right-join  左链接：left-join  全连接：all-join   内链接：init-join**/}
                      {index === 0 ? null : joinIcon ? (
                        <div className="table-join-context">
                          <SvgIcon type={joinArrow} className="table-join-port"/>
                          <SvgIcon type={joinIcon} className="table-join-tip"/>
                        </div>
                      ) : (
                        <span className="table-no-line"/>
                      )}
                      <div className="table-join-tab">{relation.table_code}</div>
                    </React.Fragment>
                  );
                })}
              </div>
            ) : (
              <div className="table-join">
                {dataTables[0].only_one_table ? '' : (
                  <div className="table-join-border">{dataTables[0].table_code?.toLowerCase()}</div>)}
                <div className="table-join-des"
                  title={getLocalText(isEn, dataTables[0]?.customize_name, dataTables[0]?.customize_name_en, dataTables[0]?.table_name)}>{getLocalText(isEn, dataTables[0]?.customize_name, dataTables[0]?.customize_name_en, dataTables[0]?.table_name)}</div>
              </div>
            )
          ) : (
            <Button className="left-btn-text" type="primary" onClick={() => {
              // 如无数据，直接把之前点击过的缓存，做清空
              props.dispatch({
                type: `${namespace}/save`,
                payload: {
                  save_column_infos: '',
                },
              });
              setActiveTab(dataTables?.[0]?.kind !== 'virtual' ? 'simple' : 'sql');
              setFromEdit(dataTables?.[0]?.kind === 'virtual');
              setDataSourceOperation('add');
              setTabs([
                {
                  id: 'simple',
                  label: formatMessage({id: 'dbl_sql_table'}),
                },
                {
                  id: 'sqlViewList',
                  label: formatMessage({id: 'dbl_sql_view_title'}),
                },
                {
                  id: 'sql',
                  label: formatMessage({id: 'dbl_sql_view_add_sql'}),
                },
                {
                  id: 'personal',
                  label: formatMessage({id: 'dbl_personal_data_title'}),
                },
              ]);
              setVisible(true);
            }}>
              {dblFormatMessage('add_data_source')}
            </Button>
          )}
        </div>
      </div>
      <Modal
        disableCloseIcon={false}
        destroyOnClose={true}
        visible={visible}
        onClose={() => setVisible(false)}
        className={isDragDrop ? `add-Source dbl-add-source dbl-add-drag-source ${simpleClass}` : 'dbl-add-source add-Source'}
        size={'80%'}
      >
        <>
          {
            isDragDrop ? <>
              <Tabs className="dbl-add-source-tab" defaultActiveId={activeTab} animated={false} ceiling tabs={tabs}
                onActive={tabsOnActive}>
                <TabPanel id="simple">
                  <AddSource
                    openDetailModal={openDetailModal}
                    formatMessage={createDblFormatMessage("dataSource")}
                    isEn={isEn}
                    commonFormatMessage={commonFormatMessage}
                    dispatch={props.dispatch}
                    chartType={chartType}
                    locale={locale}
                    gameCode={gameCode}
                    joinTables={dataSourceOperation === 'replace' ? [] : DragDataTables}
                    isHaveChart={isHaveChart}
                    autoSelectTable={autoSelectTable}
                    joinRelations={dataSourceOperation === 'replace' ? [] : dataTableJoinRelations}
                    close={() => {
                      setActiveTab('simple');
                      setFromEdit(false);
                      setVisible(false);
                    }}
                    getSuccess={({
                      joinTables,
                      joinRelations,
                      isOpenSelfJoin
                    }: {
                      joinTables: IGetTableInfoDto[];
                      joinRelations: ITableJoinRelation[];
                      isOpenSelfJoin: boolean;
                    }) => {
                      const tableIds = joinTables.map((item) => item.table_id);
                      props.dispatch({
                        type: `${namespace}/save`,
                        payload: {
                          dataTableJoinRelations: joinRelations,
                          isOpenSelfJoin,
                          // 新建保持现状，编辑回显上次的页签态
                          // mode: isEmpty(dataTables)
                          //   ? ChartCalculateMode.Aggregate
                          //   : modes,
                        },
                      });
                      props.dispatch({
                        type: `${namespace}/setTableInfo`,
                        payload: {
                          response: joinTables,
                          // 每次切换数据源，这里的table_id要每次取最新的，需要恢复以下字段
                          /**
                           *-字段操作：字段重命名、字段类型、维度/指标转换
                           -图表操作：图表显示设置、表格-升降序排序设置、表格-指标/维度字段顺序，原数据模式默认按[按sql的字段顺序呈现顺序]
                           -新增字段列表：保留已新增的字段列表，不清空
                           */
                          save_column_infos: resetDimensionPercentageOnDataSourceSwitch(
                            pick(saveColumnInfos, [
                              ...tableIds,
                              'saveRowLimits',
                              'sorts',
                              'chartsCfgSave',
                            ]),
                          ),
                        },
                        callback: (data, mode) => {
                          if (mode === ChartCalculateMode.RawColumn) {
                            const fullSelectedColumnsArray = data?.reduce(
                              (acc: string | any[], item: { column_class_list: any[]; }) => {
                                item.column_class_list.forEach((classItem) => {
                                  acc = acc.concat(classItem?.columns);
                                });
                                return acc;
                              },
                              [],
                            );
                            const fullColumnRawColumns = columnRawColumns?.filter((task: { column_custom: boolean; })=>task?.column_custom);
                            props.dispatch({
                              type: `${namespace}/switchChartCalculateMode`,
                              payload: {
                                mode,
                                columnRawColumns: [...fullSelectedColumnsArray, ...fullColumnRawColumns],
                                // TODO: Sql模式自定义字段需去除???
                                // customColumns: [],
                              },
                            });
                          }
                        },
                      });
                      props.dispatch({
                        type: `${namespace}/filterConditionByTable`,
                        payload: {
                          tables: joinTables,
                          table_ids: tableIds,
                          forceAssignEmptyHashAnalysis: true
                        },
                        callback: (payload: any) => {
                          if (payload?.errorMsg && payload?.errorCode !== 40005) {
                            notification.error({
                              className: 'dbl-analysis-msg',
                              description: payload?.errorCode === 10013 ? formatMessage({id: `dbl_error_${payload?.errorCode || '1'}`}, {name: payload?.errorData, msg: payload?.errorMsg}) : payload?.errorMsg,
                              duration: 3000,
                            });
                          }
                        }
                      });
                      // 数据源替换收起菜单
                      props.dispatch({
                        type: 'datalab/save',
                        payload: {
                          isExpendLeftMenu: false
                        }
                      });
                      const tables = joinTables.map((item) => ({
                        tableId: item.table_id,
                        tableName: item.table_name
                      }));
                      handleBtnBuriedPoint(tables);
                    }}
                    showSelfJoin={showSelfJoin}
                    isOpenSelfJoin={isOpenSelfJoin}
                    isHaveTables={isHaveTables}
                    errorFormatmessage={formatMessage}
                  />
                </TabPanel>
                <TabPanel id="sql">
                  <SqlAddSource
                    isFromEdit={isFromEdit}
                    dataTables={dataTables}
                    close={() => {
                      setActiveTab('simple');
                      setFromEdit(false);
                      setVisible(false);
                      // 数据源替换收起菜单
                      props.dispatch({
                        type: 'datalab/save',
                        payload: {
                          isExpendLeftMenu: false
                        }
                      });
                    }}
                    sqlViewUpdateDisabled={sqlViewUpdateDisabled}
                    isHaveTables={isHaveTables}
                  />
                </TabPanel>
                <TabPanel id="sqlViewList">
                  <SqlViewList
                    gameCode={gameCode}
                    commonFormatMessage={commonFormatMessage}
                    close={() => {
                      setActiveTab('simple');
                      setFromEdit(false);
                      setVisible(false);
                      // 数据源替换收起菜单
                      props.dispatch({
                        type: 'datalab/save',
                        payload: {
                          isExpendLeftMenu: false
                        }
                      });
                    }}
                    isHaveTables={isHaveTables}
                    handleBtnBuriedPoint={handleBtnBuriedPoint}
                    openDetailModal={openDetailModal}
                  />
                </TabPanel>
                <TabPanel id="personal">
                  <PersonalDataSource
                    formatMessage={createDblFormatMessage("dataSource")}
                    commonFormatMessage={commonFormatMessage}
                    dispatch={props.dispatch}
                    chartType={chartType}
                    locale={locale}
                    gameCode={gameCode}
                    joinTables={dataSourceOperation === 'replace' ? [] : DragDataTables}
                    isHaveChart={isHaveChart}
                    autoSelectTable={autoSelectTable}
                    joinRelations={dataSourceOperation === 'replace' ? [] : dataTableJoinRelations}
                    close={() => {
                      setActiveTab('simple');
                      setFromEdit(false);
                      setVisible(false);
                    }}
                    getSuccess={({
                      joinTables,
                      joinRelations,
                      isOpenSelfJoin
                    }: {
                      joinTables: IGetTableInfoDto[];
                      joinRelations: ITableJoinRelation[];
                      isOpenSelfJoin: boolean;
                    }) => {
                      const tableIds = joinTables.map((item) => item.table_id);
                      props.dispatch({
                        type: `${namespace}/save`,
                        payload: {
                          dataTableJoinRelations: joinRelations,
                          isOpenSelfJoin,
                          // 新建保持现状，编辑回显上次的页签态
                          // mode: isEmpty(dataTables)
                          //   ? ChartCalculateMode.Aggregate
                          //   : modes,
                        },
                      });
                      props.dispatch({
                        type: `${namespace}/setTableInfo`,
                        payload: {
                          response: joinTables,
                          // 每次切换数据源，这里的table_id要每次取最新的，需要恢复以下字段
                          /**
                             *-字段操作：字段重命名、字段类型、维度/指标转换
                             -图表操作：图表显示设置、表格-升降序排序设置、表格-指标/维度字段顺序，原数据模式默认按[按sql的字段顺序呈现顺序]
                             -新增字段列表：保留已新增的字段列表，不清空
                             */
                          save_column_infos: resetDimensionPercentageOnDataSourceSwitch(
                            pick(saveColumnInfos, [
                              ...tableIds,
                              'saveRowLimits',
                              'sorts',
                              'chartsCfgSave',
                            ]),
                          ),
                        },
                        callback: (data, mode) => {
                          if (mode === ChartCalculateMode.RawColumn) {
                            const fullSelectedColumnsArray = data?.reduce(
                              (acc: string | any[], item: { column_class_list: any[]; }) => {
                                item.column_class_list.forEach((classItem) => {
                                  acc = acc.concat(classItem?.columns);
                                });
                                return acc;
                              },
                              [],
                            );
                            const fullColumnRawColumns = columnRawColumns?.filter((task: { column_custom: boolean; })=>task?.column_custom);
                            props.dispatch({
                              type: `${namespace}/switchChartCalculateMode`,
                              payload: {
                                mode,
                                columnRawColumns: [...fullSelectedColumnsArray, ...fullColumnRawColumns],
                                // TODO: Sql模式自定义字段需去除???
                                // customColumns: [],
                              },
                            });
                          }
                        },
                      });
                      props.dispatch({
                        type: `${namespace}/filterConditionByTable`,
                        payload: {
                          tables: joinTables,
                          table_ids: tableIds,
                          forceAssignEmptyHashAnalysis: true
                        },
                        callback: (payload: any) => {
                          if (payload?.errorMsg && payload?.errorCode !== 40005) {
                            notification.error({
                              className: 'dbl-analysis-msg',
                              description: payload?.errorCode === 10013 ? formatMessage({id: `dbl_error_${payload?.errorCode || '1'}`}, {name: payload?.errorData, msg: payload?.errorMsg}) : payload?.errorMsg,
                              duration: 3000,
                            });
                          }
                        }
                      });
                      // 数据源替换收起菜单
                      props.dispatch({
                        type: 'datalab/save',
                        payload: {
                          isExpendLeftMenu: false
                        }
                      });
                      const tables = joinTables.map((item) => ({
                        tableId: item.table_id,
                        tableName: item.table_name
                      }));
                      handleBtnBuriedPoint(tables);
                    }}
                    showSelfJoin={showSelfJoin}
                    isOpenSelfJoin={isOpenSelfJoin}
                    isHaveTables={isHaveTables}
                    errorFormatmessage={formatMessage}
                  />
                </TabPanel>
                  
              </Tabs>
            </> : <>
              <AddSource
                openDetailModal={openDetailModal}
                isShowStep={!isDragDrop}
                formatMessage={createDblFormatMessage("dataSource")}
                isEn={isEn}
                commonFormatMessage={commonFormatMessage}
                dispatch={props.dispatch}
                locale={locale}
                gameCode={gameCode}
                joinTables={dataTables}
                isHaveChart={isHaveChart}
                autoSelectTable={autoSelectTable}
                joinRelations={dataTableJoinRelations}
                close={() => {
                  setVisible(false);
                }}
                getSuccess={({
                  joinTables,
                  joinRelations,
                  isOpenSelfJoin
                }: {
                  joinTables: IGetTableInfoDto[];
                  joinRelations: ITableJoinRelation[];
                  isOpenSelfJoin: boolean;
                }) => {
                  props.dispatch({
                    type: `${namespace}/save`,
                    payload: { dataTableJoinRelations: joinRelations, isOpenSelfJoin },
                  });

                  props.dispatch({
                    type: `${namespace}/setTableInfo`,
                    payload: { response: joinTables, },
                  });

                  props.dispatch({
                    type: `${namespace}/filterConditionByTable`,
                    payload: {
                      table_ids: joinTables.map((item) => item.table_id),
                      tables: joinTables,
                    },
                  });
                  // 数据源替换收起菜单
                  props.dispatch({
                    type: 'datalab/save',
                    payload: {
                      isExpendLeftMenu: false
                    }
                  });
                }}
                showSelfJoin={showSelfJoin}
                isOpenSelfJoin={isOpenSelfJoin}
                errorFormatmessage={formatMessage}
              /></>
          }
        </>
      </Modal>
      
      <DetailModal
        {...detailProps}
        onClose={onClose}
        goBack={onClose}
        className={'dbl-add-source-detail-modal'}
      />
    </>
  );
}
